// src/components/ContactSection.jsx
import React from "react";
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import SectionHeader from "./SectionHeader";

const ContactSection = () => (
  <Box
    id="contact"
    sx={{
      py: { xs: 6, md: 8 },
      bgcolor: "#020617",
      color: "white",
    }}
  >
    <Container maxWidth="lg">
      <Grid container spacing={4} alignItems="flex-start">
        <Grid item xs={12} md={7}>
          <SectionHeader
            kicker="Get Started"
            title="Ready to see Carbon Bridge Computing in action?"
            subtitle="Share a few details about your assets or organisation and we’ll organise a live walkthrough of the platform, tailored to your Net Zero and reporting goals."
            kickerColor="#cbd5e1"
            subtitleColor="#cbd5e1"
          />
        </Grid>
        <Grid item xs={12} md={5}>
          <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <CardContent sx={{ p: 3 }}>
              <Box
                component="form"
                onSubmit={(e) => {
                  e.preventDefault();
                  alert("Demo request submitted (placeholder).");
                }}
              >
                <TextField
                  label="Name"
                  variant="outlined"
                  fullWidth
                  required
                  margin="normal"
                />
                <TextField
                  label="Organisation"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                />
                <TextField
                  label="Work email"
                  type="email"
                  variant="outlined"
                  fullWidth
                  required
                  margin="normal"
                />
                <TextField
                  label="What would you like to achieve?"
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={4}
                  margin="normal"
                />
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{ mt: 1.5, borderRadius: 999 }}
                >
                  Request demo
                </Button>
                <Typography
                  variant="caption"
                  sx={{ mt: 1, display: "block", color: "text.secondary" }}
                >
                  By submitting, you agree we may contact you about Carbon
                  Bridge Computing.
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export default ContactSection;
